import type {
  EmergencyResponseTeamReport,
  EmergencyResponseTeamState,
} from '@/models/externalReports/emergencyResponseTeam/spEmergencyResponseTeamReport';
import {
  timeIntegerToSeconds,
  unpackTimeInteger,
} from '@/lib/dateTimeHelper';
import type { ExternalReportsLabelSp } from '@/models/apis/externalReports/external_report_settings';

export const initEmergencyResponseTeamReport = (): EmergencyResponseTeamReport => {
  return {
    id: 0,
    group1Id: 0,
    emergencyResponseTeamCarId: 0,
    baseDepartureTs: null,
    operationStartTs: null,
    operationEndTs: null,
    baseArrivalTs: null,
    hanName: null,
  };
};

export const initCommonState = (): EmergencyResponseTeamState => {
  return {
    baseDepartureTime: null,
    workStartTime: null,
    workEndTime: null,
    currentTime: null,
    carUpdateTimer: null,
    workElapsedTimeNotifyTimer: null,
    mtxStoreTimer: null,
    mtxCreateTimer: null,
    status: 'stopped',
    emergencyResponseTeamCar: {
      id: 0,
      report: initEmergencyResponseTeamReport(),
    },
    emergencyResponseTeamMtxs: [],
    lastEmergencyResponseTeamMtxTs: null,
    errorModalMsg: '',
    isRequesting: false,
    showErrorModal: false,
    showGeolocationGeneralErrorMsg: false,
    showGeolocationPermissionErrorModal: false,
    externalReportSpLabels: {
      title: {},
      button: {},
      status: {},
      field_label: {},
    } as ExternalReportsLabelSp,
    currentScreenOverride: null,
  };
};

export const notifyWorkElapsedTimeSpeech = (workElapsedTimeInt: number, doSpeech: ((text: string) => void)): void => {
  // 15分毎に経過時間を通知する
  const threshold = 900; // seconds
  const workElapsedTimeSec = timeIntegerToSeconds(workElapsedTimeInt);
  if (workElapsedTimeSec === 0) return;
  if (workElapsedTimeSec % threshold > 0) return;

  const [h, m, s] = unpackTimeInteger(workElapsedTimeInt);
  let text = '作業開始から';
  if (h > 0) {
    text += `${h}時間`;
  }
  if (m > 0) {
    text += `${m}分`;
  }
  if (s > 0) {
    text += `${s}秒`;
  }
  text += 'が経過しました。';
  doSpeech(text);
};
